import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import {ExamTypeService} from '../../../core/services/exam-type/document-type/exam-type.service'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import {MatIcon} from '@angular/material/icon';
import {ResponseRequestModel} from '../../../core/models/response.model';
import {
  MessageTypeCreateComponent
} from '../../../features/message-type/document-type-create/message-type-create.component';
import {MessageTypeEditComponent} from '../../../features/message-type/document-type-edit/message-type-edit.component';
import {MessageTypeService} from '../../../core/services/message-type/document-type/message-type.service';
import {ContentTypeService} from '../../../core/services/content-type/document-type/content-type.service';
import {ContentTypeEditComponent} from '../../../features/content-type/document-type-edit/content-type-edit.component';
import {
  ContentTypeCreateComponent
} from '../../../features/content-type/document-type-create/content-type-create.component';

@Component({
  selector: 'content-type',
  imports: [
    MatCard,
    MatProgressBar,
    TableListComponent,
    MatPaginatorModule,
    MatIcon,
    MessageTypeCreateComponent,
    ContentTypeCreateComponent,
  ],
  templateUrl: './content-type.component.html',
  styleUrl: './content-type.component.scss',
  providers: [MessageTypeService, AuthService],
  standalone: true,
})
export class ContentTypeComponent implements OnInit {
  constructor(
    private examTypeService: ContentTypeService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''
  columns: any[] = [
    { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'description',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'ativo',
      key: 'status_id',
      description: 'Ativo',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false },
      description: 'Ações',
    },
  ]
  screen: string = 'tipo-conteudo'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('excluir'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    const items = Array.isArray(response?.data)
      ? response.data
      : (Array.isArray(response?.items) ? response.items : (response?.data?.items ?? []))
    for (let item of items) {
      list.push(item)
    }
    this.itemsList = list
    this.numberRows = response?.totalItens ?? response?.paging?.total ?? response?.pagination?.total ?? this.itemsList.length
  }

  getListItems() {
    this.loading = true
    this.examTypeService
      .listContentType()
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: any) => {
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.examTypeService
      .searchPagedDocumentType(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: any) => {
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(ContentTypeEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
    this.examTypeService.deleteContentType(item.id).subscribe({
      next: (response: ResponseRequestModel)=>{
        this.uploadList()
      }, error: (error: any) =>{
        console.log(error)
      }
    })
  }

}
